import React from 'react';

import {
  Grid,
  Stack,
  Typography
} from '@mui/material';
import { ExternalLink } from 'modules';



export const FC: React.FC = () => {

  return (
    <Grid container justifyContent="center" alignItems="center" flexDirection="column" >
      <Stack mb={2} alignItems="center">
        <Typography
          color="#FFFFFF"
          fontSize={24}
          fontWeight={500}>
           What other related resources would be helpful to your
        </Typography>

        <Typography
          color="#FFFFFF"
          fontSize={24}
          fontWeight={500}>
          company? Let us know by filling out this Typeform here.
        </Typography>
      </Stack>

      <ExternalLink.Button href="https://2j035yupsmc.typeform.com/to/LRNzXVyA">
        Submit Feedback
      </ExternalLink.Button>
    </Grid>
  );
};
